export const FEATURE_FLAGS_PAGES_FAILED_ORDERS_ENABLED =
  process.env.REACT_APP_FEATURE_FLAGS_PAGES_FAILED_ORDERS_ENABLED === 'true';
export const REDIRECT_TO_LOGIN_URL = '/redirect-to-login';
export const REDIRECT_NOT_ALLOWED_URL = '/redirect-not-allowed';
export const MAX_CONTENT_WIDTH = 328;
